import { AnchorIcon, BuildingIcon, LightIcon } from "@/components/icons";
import { SectionHeader } from "@/components/SectionHeader";

const INTEGRATIONS = [
  {
    Icon: AnchorIcon,
    title: "Property Management",
    body: "Connect with leading hotel management platforms, including Oracle Opera, Mews, and Cloudbeds, so room state follows the guest.",
  },
  {
    Icon: BuildingIcon,
    title: "Building Management",
    body: "Connect Somo with existing building management systems so rooms and central plant work from the same signals.",
  },
  {
    Icon: LightIcon,
    title: "Lighting Design",
    body: "Give lighting designers the tools to configure scenes, curves, and control layouts without rewiring the room.",
  },
];

export function IntegrationsSection() {
  return (
    <section id="integrations" className="px-2 sm:px-4 py-20 md:px-6 md:py-16">
      <div className="mx-auto flex max-w-6xl flex-col gap-12 md:gap-16">
        <SectionHeader
          variant="split"
          className="px-6 sm:px-4 md:px-0"
          eyebrow="Integrations"
          title="Connect Somo to the systems behind your hotel"
          body="Somo integrates with leading hotel and building systems so the room responds to what the rest of the property already knows."
        />
        <ul className="grid gap-4 md:grid-cols-3">
          {INTEGRATIONS.map((integration) => (
            <li
              key={integration.title}
              className="flex flex-col gap-4 rounded-card border border-primary p-6 md:gap-8 md:p-10"
            >
              <integration.Icon className="size-10 text-secondary" />
              <div className="flex flex-col gap-4">
                <h3 className="text-balance text-lg leading-title text-primary md:text-2xl md:leading-snug">
                  {integration.title}
                </h3>
                <p className="text-sm leading-normal tracking-body text-secondary md:text-base md:leading-relaxed">
                  {integration.body}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
